// extracted by mini-css-extract-plugin
export var container = "_h0-0";
export var dotAnimation = "_h0-2";
export var dotsLoading = "_h0-1";